import { MDSSkeleton } from "@/mds";
import { SkeletonContainer } from "./subscription.styles";

export const LoadingSubscriptions = () => {
  return (
    <SkeletonContainer>
      <MDSSkeleton width={200} height={20} />
      <MDSSkeleton width={40} height={20} />
    </SkeletonContainer>
  );
};
